
import { useParentActions } from './family/useParentActions';
import { useFamilyDialogs } from './family/useFamilyDialogs';
import { useFamilyMutations } from './family/useFamilyMutations';

export const useFamilyActions = () => {
  const { 
    editingParent,
    setEditingParent,
    isEditParentDialogOpen,
    setIsEditParentDialogOpen,
    handleSendInvite,
    handleEditParent,
    handleParentUpdated
  } = useParentActions();

  const {
    isAddFamilyDialogOpen,
    setIsAddFamilyDialogOpen,
    isAddFamilyWithParentDialogOpen,
    setIsAddFamilyWithParentDialogOpen
  } = useFamilyDialogs();

  const {
    handleFamilyAdded,
    handleFamilyWithParentAdded,
    handleStudentAdded
  } = useFamilyMutations();

  return {
    // Parent actions
    editingParent,
    setEditingParent,
    isEditParentDialogOpen,
    setIsEditParentDialogOpen,
    handleSendInvite,
    handleEditParent,
    handleParentUpdated,
    
    // Family dialogs
    isAddFamilyDialogOpen,
    setIsAddFamilyDialogOpen,
    isAddFamilyWithParentDialogOpen,
    setIsAddFamilyWithParentDialogOpen,
    
    // Family mutations
    handleFamilyAdded,
    handleFamilyWithParentAdded,
    handleStudentAdded
  };
};
